import { useSelector } from "react-redux";
import styles from "../../../styles/Components/mini-app/mini-bots/MiniBotsList.module.css";
import { Skeleton } from "antd";
import noBot from "../../../asset/Images/no-bot.png";
import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { BotItem } from "../../bot/bot-overview/BotList";

function MiniBotsList() {
  const {
    dashboard: {
      botInfoStatus,
      overallBotPerformance: { bots_performance: bots = [] },
    },
  } = useSelector((state) => state);

  const botList = [...bots]?.sort((a, _) => (a?.status === "Active" ? -1 : 1));

  if (botInfoStatus === "loading")
    return (
      <div className={styles.container}>
        {Array.from({ length: 4 })?.map((_, index) => (
          <Skeleton.Node key={index} active className={styles.skeleton} />
        ))}
      </div>
    );

  if (botInfoStatus === "success" && bots?.length === 0)
    return (
      <div className={styles.emptyBots}>
        <LazyLoadImage
          src={noBot}
          alt="ai assistant"
          effect="blur"
          width="203px"
          height="203px"
        />
        <div className={styles.text}>
          <h4>No bots found.</h4>
          <h4>Create your first bot.</h4>
        </div>
      </div>
    );

  return (
    <div className={styles.container}>
      {botList?.map((bot) => (
        <BotItem data={bot} key={bot?.bot_creation_id} isMiniApp={true} />
      ))}
    </div>
  );
}

export default MiniBotsList;
